import variables from './variables'

export default {
  colors: {
    buttons: {
      primaryBackground: variables.colors.professionalDevelopmentPurple,
      secondaryText: variables.colors.professionalDevelopmentPurple,
      secondaryOutline: variables.colors.professionalDevelopmentPurple,
    },
  },
  anchorNavigation: {
    borderBottomStyle: 'none',
    borderBottomColor: 'none',
    borderBottomWidth: 'none',
    boxShadow: `0px 0px 10px ${variables.colors.gray300}`,
  },
}
